import { useCallback } from 'react';

import { XIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Button } from '@/components/ui/button';
import useLocalStorage from '@/hooks/useLocalStorage';
import { selectIframeView } from '@/redux/user/selectors';
import { RULES_DOCS_URL } from '@/util/constants';

export const RulesContextualHelp = () => {
  const [localDismiss, setLocalDismiss] = useLocalStorage('banners.about_rules', false);
  const isIframeView = useSelector(selectIframeView);
  const { t } = useTranslation();

  const handleDismiss = useCallback(() => {
    setLocalDismiss(true);
  }, [setLocalDismiss]);

  if (localDismiss || isIframeView) {
    return null;
  }

  return (
    <div className="relative mt-6 mb-4 rounded-md bg-info-soft p-4">
      <h3 className="mb-1 leading-none font-medium">{t('rules.contextual_help.title')}</h3>

      <div className="max-w-md text-sm">
        <p className="leading-6">
          {t('rules.contextual_help.description')}{' '}
          <a
            href={RULES_DOCS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-primary hover:underline"
          >
            {t('common.learn_more')}
          </a>
        </p>
      </div>

      <div className="absolute top-3 right-3">
        <Button
          onClick={handleDismiss}
          aria-label={t('common.close_help')}
          variant="ghost-neutral"
          size="icon-xss"
        >
          <XIcon size={16} className="text-muted-foreground" />
        </Button>
      </div>
    </div>
  );
};
